module.exports = __webpack_public_path__ + "static/media/sidebar-2.ffd65f09.jpg";